import { API_BASE_URL } from '../../config/api';
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import Paynet from './Paynet';
import { useTranslation } from 'react-i18next';

const PopupCart = ({ title, count }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [paymentData, setPaymentData] = useState(null);

  // Сброс состояния загрузки при возврате на страницу (Back button / BFCache / Tab focus)
  useEffect(() => {
    const handleReset = () => {
      setLoading(false);
      setPaymentData(null);
    };

    window.addEventListener('pageshow', handleReset);
    window.addEventListener('focus', handleReset);
    window.addEventListener('popstate', handleReset);

    return () => {
      window.removeEventListener('pageshow', handleReset);
      window.removeEventListener('focus', handleReset);
      window.removeEventListener('popstate', handleReset);
    };
  }, []);

  const showNotification = (message, type) => {
    toast(message, { type });
  };

  const handleDirectPayment = async (e) => {
    e.preventDefault();
    if (loading) return;

    setLoading(true);
    const formDataToSend = new FormData();
    formDataToSend.append('title', title);
    formDataToSend.append('count', count);

    // Страховочный таймаут для сброса кнопки, если пользователь отменил или вернулся
    const timer = setTimeout(() => {
      setLoading(false);
    }, 5000);

    try {
      const response = await axios.post(`${API_BASE_URL}/pay/payment/`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setPaymentData(response.data);
    } catch (error) {
      clearTimeout(timer);
      setLoading(false);
      showNotification(t('cart.error') || 'Что-то пошло не так при создании платежа', 'error');
    }
  };

  return (
    <div>
      {paymentData && <Paynet paymentData={paymentData} />}

      <span onClick={handleDirectPayment} className="main-content__product__cart-button put-set-to-cart" id="add-to-cart">
        <button className="btn-bay" id="btn" disabled={loading}>
          {loading ? '...' : t('cart.payment')}
        </button>
      </span>
    </div>
  );
};

export default PopupCart;
